import { render } from "./AuthPasswordResetConfirmation.vue?vue&type=template&id=b9b76a94&scoped=true"
import script from "./AuthPasswordResetConfirmation.vue?vue&type=script&lang=ts"
export * from "./AuthPasswordResetConfirmation.vue?vue&type=script&lang=ts"

import "./AuthPasswordResetConfirmation.vue?vue&type=style&index=0&id=b9b76a94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b9b76a94"

export default script